import { render, staticRenderFns } from "./CaraKerja.vue?vue&type=template&id=3688fb46&"
import script from "./CaraKerja.vue?vue&type=script&lang=js&"
export * from "./CaraKerja.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports